// 格式化金额显示
interface AmountFormatParams {
  amount: string | number; // 金额，可正数也可负数
  showSymbol?: boolean; // 是否显示符号
  currency?: 'CNY' | 'USD'; // 货币单位
}

const currencySymbolMap = {
  CNY: '¥',
  USD: '$',
};
export const formatAmount = ({ amount, showSymbol = false, currency = 'CNY' }: AmountFormatParams) => {
  const num = parseFloat(String(amount));
  if (isNaN(num)) return amount || '0.00';

  // 判断金额本身是否为负数
  const isAmountNegative = num < 0;

  // 使用绝对值进行格式化
  const formatted = Math.abs(num).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // 确定最终的正负号：如果参数指定了负数，或者金额本身是负数且参数未强制指定正数
  const shouldShowNegative = isAmountNegative;

  const currencySymbol = currencySymbolMap[currency] || currency; // 避免未定义的货币单位

  if (!showSymbol) return shouldShowNegative ? `- ${currencySymbol}${formatted}` : `${currencySymbol}${formatted}`;

  return shouldShowNegative ? `- ${currencySymbol}${formatted}` : `+ ${currencySymbol}${formatted}`;
};
